import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Menu, MenuItem } from "@mui/material";
import { Link } from "react-router-dom";
export const UserMenu = ({ anchorElUser, onUserMenuClose, onLogoutClick, }) => {
    return (_jsxs(Menu, { sx: { mt: "45px" }, id: "menu-appbar", anchorEl: anchorElUser, anchorOrigin: {
            vertical: "top",
            horizontal: "right",
        }, keepMounted: true, transformOrigin: {
            vertical: "top",
            horizontal: "right",
        }, open: Boolean(anchorElUser), onClose: onUserMenuClose, children: [_jsx(MenuItem, { component: Link, to: "/account", onClick: onUserMenuClose, children: "My Account" }), _jsx(MenuItem, { component: Link, to: "/privacy-settings", onClick: onUserMenuClose, children: "Privacy Settings" }), _jsx(MenuItem, { onClick: () => {
                    onUserMenuClose();
                    onLogoutClick();
                }, children: "Logout" })] }));
};
